import {returnCustomerOfferToCoefficientReview} from "@project/sdk/sales";
import {ReturnCustomerOfferToCoefficientReviewResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";

export function returnCustomerOfferToCoefficientReviewMutationOptions() {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.returnCustomerOfferToCoefficientReview,
    retry: false,
    mutationFn: async (id: string) =>
      ReturnCustomerOfferToCoefficientReviewResponse.parse(
        await returnCustomerOfferToCoefficientReview(id),
      ),
    onSuccess: async (_result, id, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(id)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
